export const customMerge = <T>(objValue: T, srcValue: T) => {
  if (Array.isArray(objValue)) {
    return srcValue || objValue;
  }
  if (srcValue === null) {
    return objValue;
  }
  return srcValue !== undefined ? srcValue : objValue;
};
